import { render } from "./confirmpurchase.vue?vue&type=template&id=16eb1e43&scoped=true"
import script from "./confirmpurchase.vue?vue&type=script&lang=js"
export * from "./confirmpurchase.vue?vue&type=script&lang=js"

import "./confirmpurchase.vue?vue&type=style&index=0&id=16eb1e43&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\GCTUSMS\\codev1\\apply_online\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16eb1e43"]])

export default __exports__